import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext.jsx";
import API from "../config/api.js";

const TIMEZONES = Intl.supportedValuesOf
  ? Intl.supportedValuesOf("timeZone")
  : ["America/New_York", "America/Chicago", "America/Denver", "America/Los_Angeles", "UTC"];

export default function AccountPersonalInformation() {
  const { user, refreshAuth } = useAuth();

  const [profile, setProfile]   = useState({ name: "", phone: "", timezonelocation: "UTC" });
  const [saving, setSaving]     = useState(false);
  const [alert, setAlert]       = useState(null);
  const [tzTime, setTzTime]     = useState("");

  useEffect(() => {
    if (user) setProfile({ name: user.name || "", phone: user.phone || "", timezonelocation: user.timezonelocation || "UTC" });
  }, [user]);

  useEffect(() => {
    const update = () => {
      try {
        setTzTime(new Intl.DateTimeFormat("en-US", {
          timeZone: profile.timezonelocation,
          hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false,
        }).format(new Date()));
      } catch (_) {}
    };
    update();
    const t = setInterval(update, 1000);
    return () => clearInterval(t);
  }, [profile.timezonelocation]);

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    setAlert(null);
    try {
      const fd = new FormData();
      Object.entries(profile).forEach(([k, v]) => fd.append(k, v));
      await fetch(`${API.account}?editProfile`, { method: "POST", credentials: "include", body: fd });
      setAlert({ type: "success", msg: "Profile saved!" });
      refreshAuth?.();
    } catch (_) {
      setAlert({ type: "danger", msg: "Error saving profile." });
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={handleSave}>
      <div className="border rounded-4 p-4">
        <div className="row mb-3">
          <div className="col-md-7">
            <h2 className="fs-6 fw-700">Personal Information</h2>
            <p className="text-muted">This information will be displayed publicly so be careful what you share.</p>
          </div>
          <div className="col-md-5 text-end">
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? "Saving..." : "Save"}
            </button>
          </div>
        </div>

        {alert && (
          <div className={`alert alert-${alert.type} alert-dismissible fade show`} role="alert">
            {alert.msg}
            <button type="button" className="btn-close" onClick={() => setAlert(null)} />
          </div>
        )}

        <div className="row g-4">
          <div className="col-md-6">
            <label className="text-dark mb-2 fw-700">Name</label>
            <input type="text" className="form-control form-control-lg" value={profile.name}
              onChange={(e) => setProfile((p) => ({ ...p, name: e.target.value }))} required />
          </div>
          <div className="col-md-6">
            <label className="text-dark mb-2 fw-700">Phone</label>
            <input type="text" className="form-control form-control-lg" value={profile.phone}
              onChange={(e) => setProfile((p) => ({ ...p, phone: e.target.value }))} />
          </div>
          <div className="col-md-6">
            <label className="text-dark mb-2 fw-700">Email Address</label>
            <input type="email" className="form-control form-control-lg" value={user?.email || ""} readOnly />
          </div>
          <div className="col-md-6">
            <label className="text-dark mb-2 fw-700 d-block">
              Timezone
              <span className="float-end text-muted small mt-1">
                <i className="bi bi-clock-history" /> {tzTime}
              </span>
            </label>
            <select className="form-select form-select-lg" value={profile.timezonelocation}
              onChange={(e) => setProfile((p) => ({ ...p, timezonelocation: e.target.value }))} required>
              {TIMEZONES.map((tz) => (
                <option key={tz} value={tz}>{tz}</option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </form>
  );
}
